(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const isMobile = window.matchMedia("(max-width: 767px)").matches;
    
    if (isMobile) {
      // Remove all elements with class "mobile-hide" (on mobile)
      document.querySelectorAll(".mobile-hide").forEach(el => el.remove());
    } else {
      // Remove all elements with class "desktop-hide" (on desktop)
      document.querySelectorAll(".desktop-hide").forEach(el => el.remove());
    }
  });

  } catch(e) { console.error(e); }
})();
})();
